// UX form pass bench 4 (Dee 2026-10-30): every kitchen screen shows the order code as `TKF-`
// plus the six-character short code. The rule matches the shared formatOrderId(id, shortCode)
// that bench 2 brings to src/lib/orders-api.ts; until it welds the kitchen calls this local
// copy. A trimmed, uppercased short code wins; else the uppercased last six of the order id;
// never the raw id.
export function kitchenOrderCode(orderId: string, shortCode: string | null | undefined): string {
  const code = (shortCode ?? '').trim().toUpperCase()
  if (code !== '') return `TKF-${code}`
  return `TKF-${orderId.trim().slice(-6).toUpperCase()}`
}
